import Pathify from "vuex-pathify"

Pathify.options.deep = 2

export default Pathify
